import styled from 'styled-components';

export const P = styled.p`
  margin-bottom: 15px;
`;
